var _desc, _defs, _use, _path, _polygon, _path2, _polyline, _path3, _path4, _polyline2, _path5, _polyline3, _path6, _polyline4, _path7, _polyline5, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "279px",
    height: "146px",
    viewBox: "0 0 279 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "11 135 269 135 269 11 11 11"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 258,
    height: 124,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    width: 4,
    height: 4,
    x: 7,
    y: 32,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-4"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-4",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-5",
    width: 4,
    height: 4,
    x: 211,
    y: 32,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-6"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-6",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABGdBTUEAALGOfPtRkwAAAB1JREFUCB1j/A8EDBDACKKYoBw4xQJkgWVgIhgqAAb3BAgldYidAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Features-1",
    transform: "translate(-99.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration-1",
    transform: "translate(99.000000, 262.000000)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Stroke-1",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    opacity: 0.400000006,
    strokeDasharray: 3,
    xlinkHref: "#path-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,145.5 L278.5,145.5 L278.5,0.5 L0.5,0.5 L0.5,145.5 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    stroke: "#FFFFFF",
    points: "183.129608 36.5441176 96.3648824 36.5441176 86.6156667 52.1417647 139.747451 121.359412 192.878824 52.1417647"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.191451,51.6421569 L192.877451,51.6421569",
    id: "Stroke-4",
    stroke: "#FFFFFF"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    stroke: "#FFFFFF",
    points: "96.3650196 37.0752941 118.207765 51.0588235 139.589608 37.4005882 160.913529 51.0162745 182.64098 37.1164706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.812471,51.3017647 L140.234706,120.518039",
    id: "Stroke-6",
    stroke: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.707647,51.3017647 L140.234706,119.543529",
    id: "Stroke-7",
    stroke: "#FFFFFF"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "269.740196 36.5441176 225.384902 36.5441176 215.634314 52.1417647 268.765686 121.359412"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.210784,51.6421569 L269.740196,51.6421569",
    id: "Stroke-9",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-10",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "225.384902 37.0752941 247.227647 51.0588235 268.609216 37.4005882"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.832353,51.3017647 L269.254314,120.518039",
    id: "Stroke-11",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "11.7012549 36.5441176 54.9955686 36.5441176 64.7447843 52.1417647 11.6134118 121.359412"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8581176,51.6421569 L11.7012549,51.6421569",
    id: "Stroke-13",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-14",
    stroke: "#FFFFFF",
    opacity: 0.400000006,
    points: "54.9955686 37.0752941 33.151451 51.0588235 11.7698824 37.4005882"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5481176,51.3017647 L11.1247843,120.518039",
    id: "Stroke-15",
    stroke: "#FFFFFF",
    opacity: 0.400000006
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    fill: "url(#pattern-3)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003,
    points: "11.0876259 36 54.2748902 36 64 51.4477134 11 120"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    fill: "url(#pattern-5)",
    style: {
      mixBlendMode: "exclusion"
    },
    opacity: 0.200000003,
    transform: "translate(241.500000, 78.000000) scale(-1, 1) translate(-241.500000, -78.000000) ",
    points: "215.087626 36 258.27489 36 268 51.4477134 215 120"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration1);
export default __webpack_public_path__ + "static/media/illustration-1.7431c1d24c16d37081a4012140dabf6d.svg";
export { ForwardRef as ReactComponent };